import { useState } from 'react'
import { Info, X } from 'lucide-react'

const STORAGE_KEY = 'gracealoneaba_help_hint_dismissed'

/**
 * Small dismissible banner that introduces the (i) hover-tooltip pattern
 * to first-time users. Once dismissed, stays dismissed for that browser
 * (localStorage). Sits just below the soft-launch banner in AppLayout.
 */
export default function HelpHintBanner() {
  const [dismissed, setDismissed] = useState(
    () => typeof window !== 'undefined' && window.localStorage.getItem(STORAGE_KEY) === '1'
  )

  if (dismissed) return null

  const dismiss = () => {
    window.localStorage.setItem(STORAGE_KEY, '1')
    setDismissed(true)
  }

  return (
    <div className="bg-sky-50 border-b border-sky-200 text-sky-900 text-xs">
      <div className="mx-auto max-w-7xl px-4 py-1.5 flex items-center gap-2">
        <Info className="h-3.5 w-3.5 shrink-0 text-sky-600" aria-hidden="true" />
        <span className="flex-1">
          Tip: hover over the <Info className="inline h-3 w-3 mb-0.5 text-gray-400" aria-hidden="true" /> icons throughout the app for explanations of fields, statuses, and metrics.
        </span>
        <button
          onClick={dismiss}
          aria-label="Dismiss tip"
          className="text-sky-700 hover:text-sky-900 transition-colors"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  )
}
